import { ReactElement } from 'react';

import CrossSVG from '../../../assets/cross.svg';
import TickSVG from '../../../assets/tick.svg';
import { ColumnProps } from './Table/types/ColumnProps';
type Data = {
  features: string | ReactElement;
  standardPackage: string | ReactElement;
  professionalPackage: string | ReactElement;
  enterprisePackage: string | ReactElement;
};

export const data = [
  {
    features: 'Quantity',
    standardPackage: '1-10',
    professionalPackage: '11-50',
    enterprisePackage: '50+',
  },
  {
    features: 'Price perPrintout',
    standardPackage: '€ 20.00',
    professionalPackage: '€ 15.00',
    enterprisePackage: '€ 15.00',
  },
  {
    features: 'Material/Finish Options',
    standardPackage: <img src={TickSVG} alt="success" width={20} height={20} />,
    professionalPackage: (
      <img src={TickSVG} alt="success" width={20} height={20} />
    ),
    enterprisePackage: (
      <img src={TickSVG} alt="success" width={20} height={20} />
    ),
  },
  {
    features: 'Postage Options',
    standardPackage: <img src={TickSVG} alt="success" width={20} height={20} />,
    professionalPackage: (
      <img src={CrossSVG} alt="danger" width={20} height={20} />
    ),
    enterprisePackage: (
      <img src={CrossSVG} alt="danger" width={20} height={20} />
    ),
  },
  {
    features: 'Customization Options',
    standardPackage: <img src={CrossSVG} alt="danger" width={20} height={20} />,
    professionalPackage: (
      <img src={CrossSVG} alt="danger" width={20} height={20} />
    ),
    enterprisePackage: (
      <img src={CrossSVG} alt="danger" width={20} height={20} />
    ),
  },
];
export const columns: Array<ColumnProps<Data>> = [
  {
    key: 'features',
    label: 'Features',
  },
  {
    key: 'standardPackage',
    label: 'Standard',
    render: (_, record) => {
      return <div>{record.standardPackage}</div>;
    },
  },
  {
    key: 'professionalPackage',
    label: 'Professional',

    //   render: (_, record) => {
    //     return (
    //       <div
    //         className="text-blue-500 font-bold"
    //         style={{ color: 'red', fontWeight: 'bold' }}
    //       >
    //         {record.professionalPackage}
    //       </div>
    //     );
    //   },
  },
  {
    key: 'enterprisePackage',
    label: 'Enterprise',
  },
];

export const data1 = [
  {
    features: 'Quantity',
    standardPackage: '1-10',
    professionalPackage: '11-50',
    enterprisePackage: '50+ Posters',
  },
  {
    features: 'Price perPrintout',
    standardPackage: '€ 20.00',
    professionalPackage: '€ 15.00',
    enterprisePackage: '€ 15.00',
  },
  {
    features: 'Material/Finish Options',
    standardPackage: (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}
      >
        <li>Print onto 3mm White Acrylic</li>
        <li>Back print onto 3mm Clear Acrylic</li>
        <li>Fluorescent Background</li>
        <li>Drill holes: Yes/No</li>
        <li>Stainless Steel Bracket screws</li>
        <li>Select A4 or A3</li>
      </div>
    ),
    professionalPackage: (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}
      >
        <li>Print onto 3mm White Acrylic</li>
        <li>Back print onto 3mm Clear Acrylic</li>
        <li>Fluorescent Background</li>
        <li>Drill holes: Yes/No</li>
        <li>Stainless Steel Bracket screws</li>
        <li>Select A4 or A3</li>
      </div>
    ),
    enterprisePackage: (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}
      >
        <li>Print onto 3mm White Acrylic</li>
        <li>Back print onto 3mm Clear Acrylic</li>
        <li>Fluorescent Background</li>
        <li>Drill holes: Yes/No</li>
        <li>Stainless Steel Bracket screws</li>
        <li>Select A4 or A3</li>
      </div>
    ),
  },
  {
    features: 'Postage Options',
    standardPackage: <p>Standard or Express</p>,
    professionalPackage: (
      <img src={CrossSVG} alt="danger" width={20} height={20} />
    ),
    enterprisePackage: (
      <img src={CrossSVG} alt="danger" width={20} height={20} />
    ),
  },
  {
    features: 'Customization Options',
    standardPackage: <img src={CrossSVG} alt="danger" width={20} height={20} />,
    professionalPackage: (
      <img src={CrossSVG} alt="danger" width={20} height={20} />
    ),
    enterprisePackage: (
      <img src={CrossSVG} alt="danger" width={20} height={20} />
    ),
  },
];
export const columns1: Array<ColumnProps<Data>> = [
  {
    key: 'features',
    label: 'Features',
  },
  {
    key: 'standardPackage',
    label: 'Standard Package',
    render: (_, record) => {
      return <div>{record.standardPackage}</div>;
    },
  },
  {
    key: 'professionalPackage',
    label: 'Professional Package',

    //   render: (_, record) => {
    //     return (
    //       <div
    //         className="text-blue-500 font-bold"
    //         style={{ color: 'red', fontWeight: 'bold' }}
    //       >
    //         {record.professionalPackage}
    //       </div>
    //     );
    //   },
  },
  {
    key: 'enterprisePackage',
    label: 'Enterprise Package',
  },
];
